import { Point } from "../../domain/drawing";
import { DragKinds } from "./DragKinds";

export class DragParameter {
  constructor(public dragKind: DragKinds, public offset: Point = null, public isAspectRatioFixed: boolean = false) {}
}
